export default "__VITE_PUBLIC_ASSET__9de2c93a__"